import React from 'react';

import PoweredByTOMIS from './icons/PoweredByTOMIS';
import { useSession } from '../context';
import { Category, logError } from '.././sentry-iframe';
import { SITE_SLUG } from '../consts';
import { GA4Event, trackGA4Event } from '../../tracking';
import { PARENT_PAGE_VIEW } from '..';

export const footerHeight = 26;

const hoverStyles = {
  opacity: 0.65,
  transition: 'opacity 0.2s',
  '&:hover': { opacity: 1 },
};

const ChatWindowFooter = React.memo(() => {
  const { conversation, site } = useSession();
  const parentDomain = PARENT_PAGE_VIEW.page.url.hostname;
  const isTestDomain =
    parentDomain === 'app.tomis.tech' || parentDomain === 'localhost';

  const isTestMode = Boolean(conversation.value.testMode);

  let botIsLive = true;

  try {
    if (site.botConfig.buildStages) {
      const currentStage = site.botConfig.buildStages.find(
        stage => stage.status === 'current'
      );

      if (currentStage && currentStage.id !== 'launch') {
        botIsLive = false;
      }
    }
  } catch (error) {
    console.error(error);
  }

  /** Mark conversation as test mode.
   * Does NOT start a new conversation.
   */
  function toggleTestMode() {
    conversation.ref.update({ testMode: !isTestMode }).catch(error => {
      logError(error.message, {
        category: Category.Conversations,
        level: 'error',
        message: 'Could not toggle conversation testMode',
      });
    });
  }

  return (
    <div
      css={(theme: Theme) => ({
        flex: `0 0 ${footerHeight}px`,
        backgroundColor: theme.colors.primary,
        borderRadius: '0 0 4px 4px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        lineHeight: 0,
        padding: '0 10px',
      })}
    >
      <a
        css={hoverStyles}
        href={`https://tomis.tech/?utm_source=${SITE_SLUG}&utm_medium=chatbot&utm_campaign=powered_by_tomis`}
        target="_blank"
        title="Powered by TOMIS"
        onClick={() => {
          trackGA4Event(GA4Event.ClickedPoweredByTomis);
        }}
      >
        {site.botConfig.removeBranding ? null : <PoweredByTOMIS />}
      </a>
      {botIsLive && (isTestMode || isTestDomain) && (
        <button
          onClick={toggleTestMode}
          css={{
            ...hoverStyles,
            background: 'none',
            color: 'white',
            border: '1px solid white',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
          }}
        >
          {isTestMode ? 'Exit Test Mode' : 'Test Mode'}
        </button>
      )}
      {/* <a
        css={{
          color: "white",
          fontSize: 10,
          textDecoration: "none",
          lineHeight: 0,
          ...hoverStyles
        }}
        href="https://tomis.tech/privacy-policy"
        target="_blank"
      >
        Privacy Policy
      </a> */}
    </div>
  );
});

export default ChatWindowFooter;
